export interface ClientView {
  account_ext_id: string;
  account_name: string;
  platform: string;
  metrics: string[];
  graph_one: {
    metric_one: string | null;
    metric_two: string | null;
  };
  graph_two: {
    metric_one: string | null;
    metric_two: string | null;
  };
  graph_three: {
    metric_one: string | null;
    metric_two: string | null;
  };
}

export const FALLBACK_DEFAULT_CLIENT: ClientView = {
  metrics: [
    'clicks',
    'impressions',
    'conversions',
    'ctr',
    'spend',
    'cpa',
    'cpm',
    'video_completion_rate',
    'audio_completion_rate',
    'geo',
    'domain',
    'app',
  ],
  graph_one: {
    metric_one: 'spend',
    metric_two: 'impressions',
  },
  graph_two: {
    metric_one: 'clicks',
    metric_two: 'conversions',
  },
  graph_three: {
    metric_one: 'cpa',
    metric_two: null,
  },
  platform: 'Default',
  account_name: 'Default',
  account_ext_id: 'default',
};

export interface Client {
  brand: string | null;
  title: string;
  ext_client_id: string;
  views: ClientView[];
}

export interface CreateClientRequest {
  title: string;
  views: ClientView[];
}

export interface ClientUserResponse {
  user: {
    email: string;
    first_name: string | null;
    last_name: string | null;
    ext_user_id: string;
    is_client_admin: boolean;
  };
  status: 'active' | 'inactive';
}

export interface ClientUser {
  email: string;
  name: string;
  id: string;
  is_client_admin: boolean;
}

export interface InviteCodeResponse {
  ext_client_id: string;
  invite_code: string;
}

export interface ClientAccessAccount {
  account_id: string;
  campaigns: string[];
}
export interface ClientAccessPlatform {
  source: string;
  accounts: ClientAccessAccount[];
}

export interface ClientAccessRequest {
  ext_client_id: string;
  source: string;
  account: string;
  campaigns: string[];
}